import React from "react";
import logo from "../../assets/brand/adaudit-logo.svg";

// Shown to a signed-in login that isn't linked to an account (agency_members)
// yet. It can't see or start scans until it is.
export default function NotLinked({ email, onSignOut }) {
  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif" }} className="min-h-screen bg-violet-50/[0.15] flex items-center justify-center px-6">
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap" rel="stylesheet" />
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <img src={logo} alt="AdAudit" className="h-[2rem] w-auto select-none" />
        </div>
        <div className="bg-white border border-slate-200 rounded-xl p-6">
          <h1 className="text-lg font-bold text-slate-900 mb-1">No account yet</h1>
          <p className="text-sm text-slate-500 mb-6">
            {email ? <><span className="text-slate-800">{email}</span> isn't</> : "This login isn't"} linked to an account yet. Ask AdAudit to link it, then sign in again.
          </p>
          <button type="button" onClick={onSignOut} className="w-full bg-violet-100 text-violet-800 border border-violet-200 font-semibold py-3 rounded-lg text-sm hover:bg-violet-200 transition-colors">
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
